import { observer } from 'mobx-react-lite';
import React from 'react';

import DeleteConfirmationModal from 'common/DeleteConfirmationModal';
import { rideDetailsStore } from 'pages/RideDetails/RideDetailsStore';

import { MODAL_DELETE_EXTRA_ACTIVITY_TEXT } from './text';

const resolveLoadingState = (isDeletingExtraActivity) =>
	typeof isDeletingExtraActivity === 'function'
		? isDeletingExtraActivity()
		: isDeletingExtraActivity;

const ModalDeleteExtraActivity = observer(
	({
		initialData = {},
		isDeletingExtraActivity = () => rideDetailsStore.isDeletingExtraActivity,
		onClose,
		onDeleteExtraActivityAssignment = rideDetailsStore.rejectExtraActivityAssignment,
	}) => {
		const handleConfirm = async () => {
			const success = await onDeleteExtraActivityAssignment(initialData.workAssignmentKey);

			if (success) {
				onClose();
			}
		};

		return (
			<DeleteConfirmationModal
				active
				itemLabel={MODAL_DELETE_EXTRA_ACTIVITY_TEXT.itemLabel}
				extraLabel={MODAL_DELETE_EXTRA_ACTIVITY_TEXT.extraLabel}
				loading={resolveLoadingState(isDeletingExtraActivity)}
				onCancel={onClose}
				onConfirm={handleConfirm}
				title={MODAL_DELETE_EXTRA_ACTIVITY_TEXT.title}
			/>
		);
	}
);

export default ModalDeleteExtraActivity;
